<template>
  <div class="modal fade" id="AddCodificationModal" tabindex="-1" role="dialog" ref="addCodificationModalRef" aria-labelledby="tooltipmodal" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">{{ title }}</h4>
                <button class="btn-close py-0" type="button" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
          <Form ref="codificationForm" @submit="addCodification" :validation-schema="codificationSchema">
            <div class="row">
              <div class="col-md-6 mb-3">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">
                 Numérotation <span class="text-danger">*</span>
                </label>
                <Field  name="numerotation" v-model="numerotation" v-slot="{ field }">
                  <Multiselect
                    :options="['Manuel', 'Automatique']"
                    :searchable="true"
                    track-by="label"
                    label="label"
                    v-model = "field.value"
                    v-bind = "field"
                    placeholder="Sélectionner la numérotation"
                  />
                </Field>  
                <ErrorMessage name="numerotation" class="text-danger"/>
              </div>
            </div>
           
          <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Longueur <span class="text-danger">*</span>
                  </label>
                  <Field name="longueur" type="text" 
                  class="form-control shadow-none fs-md-15 text-black"
                  :disabled="longueurDisabled" />
                  <ErrorMessage name="longueur" class="text-danger"/>
                </div>
              </div>
            <div class="col-md-6 mb-3">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Type racine <span class="text-danger">*</span>
              </label>
              <Field  name="typeRacine" v-model="typeRacine"  type="text"  v-slot="{ field }">
                <Multiselect
                  :searchable = "true"
                  :options = "['Racine fixe', 'Racine famille']"
                  v-model = "field.value"
                  v-bind = "field"
                  placeholder="Sélectionner le type"
                  :disabled="typeRacineDisabled"
                />
              </Field>
                <ErrorMessage name="typeRacine" class="text-danger"/>
            </div>
          </div>
              <div class="col-md-6 mb-3">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Racine <span class="text-danger">*</span>
                  </label>
                  <Field name="racine" type="text" 
                  class="form-control shadow-none fs-md-15 text-black"
                  :disabled="racineDisabled"/>
                  <ErrorMessage name="racine" class="text-danger"/>
                </div>
              </div>
            <button ref="submitButton"
              class="btn btn-primary"
              type="submit"
            >
            {{ btntext }}
            </button>
      </div>
        </Form>
        </div>
        <!-- <button
          type="button"
          class="btn-close shadow-none"
          data-bs-dismiss="modal"
          aria-label="Close"
          @click="resetValue()"
        ></button> -->
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, ref, watch } from 'vue';
import { Form, Field, ErrorMessage } from 'vee-validate';
import ApiService from '@/services/ApiService';
import * as Yup from 'yup';
import { hideModal } from '@/utils/utils';
import { Codification } from '@/models/Codification';
import { error , success } from '@/utils/utils';
import { useRouter } from 'vue-router';
import Multiselect from '@vueform/multiselect'
import axios from 'axios';


export default defineComponent({
    name: "AddCodificationModal",
    components: {
    Form,
    Field,
    ErrorMessage,
    Multiselect
  },
  props: {
    item: {
      type: Number,
      default: 0,
    }
  },
  setup(props, { emit }){
    const codificationSchema = Yup.object().shape({
      numerotation: Yup.string().required("La numérotation est obligatoire"),
      typeRacine: Yup.string().when([], (value, schema) => {
        return !(numerotation.value === 'Manuel')
          ? schema.required("Le type est obligatoire")
          : schema.notRequired()
      }),
      longueur: Yup.string().when([], (value, schema) => {
        return !(numerotation.value === 'Manuel')
          ? schema.required("Le type est obligatoire")
          : schema.notRequired()
      }),
      racine: Yup.string().when([], (value, schema) => {
        return (typeRacine.value === 'Racine fixe')
          ? schema.required("Le type est obligatoire")
          : schema.notRequired()
      }),

    });

    const codificationForm = ref<Codification | null>(null);
    const addCodificationModalRef = ref<null | HTMLElement>(null);
    const router = useRouter();
    // const item = ref({ ...props.item });
    const localItem = ref(props.item);
    const isUPDATE = ref(false);
    const title = ref("Ajouter une codification");
    const btntext = ref('Ajouter');
    // const produitOptions = ref([]);

    
    const codificationOptions = ref([]);
    const submitButton = ref<HTMLButtonElement | null>(null);
    // const item = ref({ ...props.item });
    
    const numerotation = ref<string | null>(null);
    const typeRacine = ref<string | null>(null);

const longueurDisabled = computed(() => numerotation.value === 'Manuel');
const typeRacineDisabled = computed(() => numerotation.value === 'Manuel');
const racineDisabled = computed(() => numerotation.value === 'Manuel' || typeRacine.value === 'Racine famille');


    watch(() => props.item, (newValue) => {
      getCodification(newValue);
      isUPDATE.value = true;
      btnTitle();
    });

    const btnTitle = async () => {
      if (isUPDATE.value) {
         title.value = "Modifier la codification";
         btntext.value = "Modifier";
      }else{
         title.value = "Ajouter une codification";
         btntext.value = "Ajouter"
      }
    }

    const getCodification = async (id: number) => {
      return ApiService.get("/codifications/"+id)
      .then(({ data }) => {
        // map data in form
        const donnees = data.data;
        for (const key in donnees) {
          codificationForm.value?.setFieldValue(key, 
          (typeof donnees[key] === 'object' && donnees[key] !== null)? donnees[key].id :donnees[key]
          );
        }
        emit('openmodal', addCodificationModalRef.value);

      })
      .catch(({ response }) => {
        error(response.data.message)
      });
    }


    
    const addCodification = async (values: any, codificationForm) => {
      if (submitButton.value) {
        // eslint-disable-next-line
        submitButton.value.disabled = true;
      }
      values = values as Codification;
      if(isUPDATE.value){
        ApiService.put("/codifications/"+values.id,values)
        .then(({ data }) => {
            if(data.code == 200) { 
              success(data.message);
              codificationForm.resetForm();
              hideModal(addCodificationModalRef.value);
              isUPDATE.value=false;
              btnTitle();
              emit('close');
            }
        })
        .catch(({ response }) => {
            error(response.data.message);
        });
      }else{
        console.log('values',values)
        ApiService.post("/codifications",values)
        .then(({ data }) => {
            if(data.code == 201) { 
              success(data.message);
              codificationForm.resetForm();
              hideModal(addCodificationModalRef.value);
              emit('close');
            }
        })
        .catch(({ response }) => {
          submitButton.value!.disabled = false;
            error(response.data.message);
        });
      }
    };

    const resetValue = () => {
      const formFields = document.querySelectorAll<HTMLInputElement | HTMLTextAreaElement>('input, textarea');
        isUPDATE.value=false;
      formFields.forEach(field => {
        field.value = '';
      });
      btnTitle()
    };

    return { codificationSchema,
      addCodificationModalRef,
      addCodification,
      codificationForm,numerotation,
      typeRacine,typeRacineDisabled,
      longueurDisabled,
      submitButton,
      racineDisabled,codificationOptions,
      title,btntext,resetValue
    };
  },
});
</script>@/models/CategorieInfo